import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import MaterialSelector from './../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class X40OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
        this.handleFabricChange = this.handleFabricChange.bind(this);
    }


    handleCupboardsChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsOwnersCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricCabins = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = ownerscabinImageOptions;

        let image = <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='To add more storage or cargo space in the owner’s cabin, you have an option for upper cupboards.' /></p>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint - and if optional upper cupboards are selected, the lighting is fitted below the cupboards.' /></p>
                    <Toggle checked={this.props.configuration.CupboardsOwnersCabin.value === 2} onChange={this.handleCupboardsChange}>
                            <Trans defaults='Upper cupboards' />
                    </Toggle>

                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricCabins.label} value={this.props.configuration.FabricCabins} onChange={this.handleFabricChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40OwnersCabin);


// WEBPACK FOOTER //
// ./src/X40/X40OwnersCabin.js